/**
 *  This class is the parent of each of the other result classes
 *  It contains a boolean for success and an error message which is populated if
 *  the result is unsuccessful
 */

class Result {
	private _success: boolean;
	private _message: string;

	/**
	 * @param success whether the request was successfully
	 * @param message contains the error if the request was unsuccessful
	 */
	constructor(success: boolean, message: string) {
		this._success = success;
		this._message = message;
	}

	get success(): boolean {
		return this._success;
	}

	set success(value: boolean) {
		this._success = value;
	}

	get message(): string {
		return this._message;
	}

	set message(value: string) {
		this._message = value;
	}
}

export default Result;
